import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSlackIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M8.0285 14.6104C8.0285 15.5355 7.27281 16.2912 6.34775 16.2912C5.42268 16.2912 4.66699 15.5355 4.66699 14.6104C4.66699 13.6854 5.42268 12.9297 6.34775 12.9297H8.0285V14.6104Z",
			fill: "#E01E5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.875 14.6104C8.875 13.6854 9.63069 12.9297 10.5558 12.9297C11.4808 12.9297 12.2365 13.6854 12.2365 14.6104V18.8188C12.2365 19.7439 11.4808 20.4996 10.5558 20.4996C9.63069 20.4996 8.875 19.7439 8.875 18.8188V14.6104Z",
			fill: "#E01E5A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5558 7.86151C9.63069 7.86151 8.875 7.10582 8.875 6.18075C8.875 5.25569 9.63069 4.5 10.5558 4.5C11.4808 4.5 12.2365 5.25569 12.2365 6.18075V7.86151H10.5558Z",
			fill: "#36C5F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5561 8.70898C11.4812 8.70898 12.2369 9.46467 12.2369 10.3897C12.2369 11.3148 11.4812 12.0705 10.5561 12.0705H6.34775C5.42268 12.0705 4.66699 11.3148 4.66699 10.3897C4.66699 9.46467 5.42268 8.70898 6.34775 8.70898H10.5561Z",
			fill: "#36C5F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3057 10.3897C17.3057 9.46467 18.0614 8.70898 18.9864 8.70898C19.9115 8.70898 20.6672 9.46467 20.6672 10.3897C20.6672 11.3148 19.9115 12.0705 18.9864 12.0705H17.3057V10.3897Z",
			fill: "#2EB67D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.4592 10.3891C16.4592 11.3142 15.7035 12.0699 14.7784 12.0699C13.8533 12.0699 13.0977 11.3142 13.0977 10.3891V6.18075C13.0977 5.25569 13.8533 4.5 14.7784 4.5C15.7035 4.5 16.4592 5.25569 16.4592 6.18075V10.3891Z",
			fill: "#2EB67D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7784 17.1387C15.7035 17.1387 16.4592 17.8944 16.4592 18.8194C16.4592 19.7445 15.7035 20.5002 14.7784 20.5002C13.8533 20.5002 13.0977 19.7445 13.0977 18.8194V17.1387H14.7784Z",
			fill: "#ECB22E"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.7784 16.2912C13.8533 16.2912 13.0977 15.5355 13.0977 14.6104C13.0977 13.6854 13.8533 12.9297 14.7784 12.9297H18.9868C19.9119 12.9297 20.6676 13.6854 20.6676 14.6104C20.6676 15.5355 19.9119 16.2912 18.9868 16.2912H14.7784Z",
			fill: "#ECB22E"
		})
	]
});
const ForwardRef = forwardRef(SvgSlackIcon);
export { ForwardRef as ReactComponent };
